class ImageTextOption extends BaseOption {
    constructor(container) {
        super(container);
        
        if (this.container.find('.pc-option-pp-sides-value').length) {
            this.initPPSidesHandler();
        }

        this.initSlider();
        this.checkElementsCount();

        window.addEventListener('resize', () => {
            this.checkElementsCount();
        });
    }

    checkElementsCount() {
        const totalSlides = this.container.find('.swiper-slide').length;
        if (window.innerWidth > 990 && totalSlides <= 4) {
            this.container.addClass('pc-option-not-enough-slides');
        }else if(window.innerWidth < 990 && window.innerWidth > 768 && totalSlides <= 4){
            this.container.addClass('pc-option-not-enough-slides');
        }else if(window.innerWidth < 768 && window.innerWidth > 580 && totalSlides <= 3){
            this.container.addClass('pc-option-not-enough-slides');
        }else if(window.innerWidth <= 580 && totalSlides < 2){
            this.container.addClass('pc-option-not-enough-slides');
        }else{
            this.container.removeClass('pc-option-not-enough-slides');
        }
    }

    initPPSidesHandler() {
        this.container.on('click', '.pc-option-pp-sides-value', (e) => {
            const $value = $(e.currentTarget);
            const index = $value.data('index');
            
            const $select = this.container.find('select[name="attribute_pp_sides"]');
            
            if ($select.length) {
                $select.val(index).trigger('change');
            }
        });
    }

    initSlider() {
        const initializeSlider = () => {
            const slider = this.container.find('.pc-option-image_text__content');
            
            if (!slider.length) return;

            const prevArrow = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 19L8 12L15 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;

            if (this.swiper) {
                this.swiper.destroy(true, true);
            }

            try {
                this.swiper = new Swiper(slider[0], {
                    slidesPerView: 4,
                    spaceBetween: 16,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 10,
                            navigation: false
                        },
                        580: {
                            slidesPerView: 2.3,
                            spaceBetween: 12,
                            navigation: false
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 14
                        },
                        990: {
                            slidesPerView: 4,
                            spaceBetween: 16
                        }
                    }
                });

                slider.find('.swiper-button-prev').html(prevArrow);
                slider.find('.swiper-button-next').html(prevArrow);
            } catch (error) {
                console.error('Error initializing Swiper:', error);
            }
        }

        initializeSlider();
        const debouncedInitialize = this.debounce(initializeSlider, 250);
        window.addEventListener('resize', debouncedInitialize);
    }

    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
} 
